/**
 * Created by andrey on 25.08.2021.
 */

const PropertiesPacker = {
    compactProperties: function (data, splitter) {
        let list = splitter(data);

        const context = {};

        list.forEach((item) => {
            const index = item.indexOf("{");
            if (index !== -1) {
                item.substr(index + 1, item.length - 1 - index - 1).split(",").forEach((property) => {
                    context[property] = (context[property] || 0) + 1;
                });
            }
        });

        const contextProperties = Object.keys(context)
            .filter((code) => context[code] > 1)
            .sort((a, b) => context[b] - context[a])
            .slice(0, 80);

        const contextCodes = {};
        contextProperties.forEach((property, code) => {
            contextCodes[property] = Base80.compactNumber(code);
        });

        list = list.map((item) => {
            const index = item.indexOf("{");

            if (index === -1) {
                return item;
            }

            const properties = item.substr(index + 1, item.length - 1 - index - 1).split(",").map((property) => contextCodes[property] || property).join(",");

            return `${item.substr(0, index)}{${properties}}`;
        });

        let contextCodesStr = "";

        if (contextProperties.length > 0) {
            contextCodesStr = `[${contextProperties.join(",")}]`;
        }

        return contextCodesStr + list.join("");
    },

    expandProperties: function (data, splitter) {
        if (data.charAt(0) !== "[") {
            return data;
        }

        const context = {};

        const endIndex = data.indexOf("]");
        data.substr(1, endIndex - 1).split(",").forEach((property, index) => {
            context[Base80.compactNumber(index)] = property;
        });

        data = data.substr(endIndex + 1);

        let items = splitter(data);

        items = items.map((item) => {
            const index = item.indexOf("{");

            if (index === -1) {
                return item;
            }

            const properties = item.substr(index + 1, item.length - 1 - index - 1).split(",").map((property) => context[property] || property).join(",");

            return `${item.substr(0, index)}{${properties}}`;
        });

        return items.join("");
    }
};

if (typeof cc === "undefined") {
    module.exports = PropertiesPacker;
}